@if (dataSource.data.length) {
  <procure-expansion-panel
    class="post-attachments"
    label="Attachments"
    flat
    [expanded]="false"
    [badge]="dataSource.data.length"
  >
    <div class="post-attachments__table-wrapper">
      <table
        class="post-attachments__table"
        aria-label="Attachments"
        mat-table
        matSort
        [dataSource]="dataSource"
      >
        <ng-container matColumnDef="fileName">
          <th
            *matHeaderCellDef
            class="post-attachments__column post-attachments__column--fileName"
            mat-header-cell
            mat-sort-header="name"
          >
            Name
          </th>
          <td
            *matCellDef="let file"
            mat-cell
          >
            <div class="post-attachments__file-name">
              <procure-file-icon [extension]="file.fileName | fileExtension" />
              <span [matTooltip]="getUserName(file)">{{ file.fileName }}</span>
            </div>
          </td>
          <td
            *matFooterCellDef
            class="post-attachments__footer-cell"
            mat-footer-cell
          ></td>
        </ng-container>
        <ng-container matColumnDef="fileUploadDate">
          <th
            *matHeaderCellDef
            class="post-attachments__column post-attachments__column--fileUploadDate"
            mat-header-cell
            mat-sort-header="type"
          >
            Upload Date
          </th>
          <td
            *matCellDef="let file"
            mat-cell
          >
            {{ file.uploadDate | date }}
          </td>
          <td
            *matFooterCellDef
            class="post-attachments__footer-cell"
            mat-footer-cell
          ></td>
        </ng-container>
        <ng-container matColumnDef="fileSize">
          <th
            *matHeaderCellDef
            class="post-attachments__column post-attachments__column--fileSize"
            mat-header-cell
            mat-sort-header="size"
          >
            Size
          </th>
          <td
            *matCellDef="let file"
            mat-cell
          >
            {{ file.fileSize | fileSize }}
          </td>
          <td
            *matFooterCellDef
            class="post-attachments__footer-cell"
            mat-footer-cell
          >
            {{ combinedFileSize | fileSize }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th
            *matHeaderCellDef
            class="post-attachments__cell-small post-attachments__column post-attachments__column--actions"
            mat-header-cell
          >
            Actions
          </th>
          <td
            *matCellDef="let file"
            class="post-attachments__file-actions"
            mat-cell
          >
            <div class="post-attachments__file-actions-wrap">
              <button
                class="post-attachments__file-button"
                procure-button
                variant="stroked"
                [matTooltip]="getUserName(file)"
                [disabled]="isCurrentDocumentDownloading(file)"
                [loading]="isCurrentDocumentDownloading(file)"
                (click)="downloadSingleDocument(file)"
              >
                <mat-icon>cloud_download</mat-icon>
                @if (file.downloadError) {
                  <mat-icon class="error-icon"> block </mat-icon>
                }
              </button>
            </div>
          </td>
          <td
            *matFooterCellDef
            class="post-attachments__footer-cell"
            mat-footer-cell
          ></td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns"
          mat-header-row
        ></tr>
        <tr
          *matRowDef="let attachment; columns: displayedColumns"
          mat-row
        ></tr>
        <tr
          *matFooterRowDef="displayedColumns"
          mat-footer-row
        ></tr>
      </table>
    </div>
  </procure-expansion-panel>
}
